export type TCensorshipDownloadPath = "backend-direct" | "local-canvas";

export const getCensorshipDownloadPath = ({
  isDebugMode,
  isEdited,
  forceLocalCanvas = false,
}: {
  isDebugMode: boolean;
  isEdited: boolean;
  forceLocalCanvas?: boolean;
}): TCensorshipDownloadPath =>
  isDebugMode || isEdited || forceLocalCanvas
    ? "local-canvas"
    : "backend-direct";
